// export const menuItems = [
//     {
//         id: 1,
//         label: 'menuitems.dashboards.text',
//         isTitle: true
//     },
//     {
//         id: 2,
//         label: 'menuitems.sales.text',
//         icon: 'monitor',
//         link: '#',
//         badge: {
//             variant: 'badge-soft-secondary',
//             text: 'menuitems.sales.badge',
//         },
//     },
//     {
//         id: 4,
//         label: 'menuitems.applications.text',
//         isTitle: true
//     },
    
//     {
//         id: 6,
//         label: 'menuitems.kanbanboard.text',
//         icon: 'trello',
//         link: '#d'
//     },
//     {
//         id: 8,
//         label: 'menuitems.email.text',
//         icon: 'mail',
//         subItems: [
//             {
//                 id: 9,
//                 label: 'menuitems.email.list.inbox',
//                 link: '#',
//                 parentId: 8
//             },
//             {
//                 id: 10,
//                 label: 'menuitems.email.list.reademail',
//                 link: '#',
//                 parentId: 8
//             }
//         ]
//     },
//     {
//         id: 21,
//         label: 'menuitems.pages.text',
//         isTitle: true
//     },
//     {
//         id: 22,
//         label: 'menuitems.authentication.text',
//         icon: 'user',
//         badge: {
//             variant: 'info',
//             text: 'menuitems.authentication.badge',
//         },
//         subItems: [
//             {
//                 id: 23,
//                 label: 'menuitems.authentication.list.signin',
//                 subItems: [
//                     {
//                         id: 24,
//                         label: 'menuitems.authentication.list.basic',
//                         link: '#',
//                         parentId: 23
//                     },
//                     {
//                         id: 25,
//                         label: 'menuitems.authentication.list.cover',
//                         link: '#',
//                         parentId: 23
//                     },
//                 ]
//             },
//             {
//                 id: 26,
//                 label: 'menuitems.authentication.list.signup',
//                 subItems: [
//                     {
//                         id: 27,
//                         label: 'menuitems.authentication.list.basic',
//                         link: '#',
//                         parentId: 26
//                     },
//                     {
//                         id: 28,
//                         label: 'menuitems.authentication.list.cover',
//                         link: '#',
//                         parentId: 26
//                     },
//                 ]
//             },
//             {
//                 id: 29,
//                 label: 'menuitems.authentication.list.signout',
//                 subItems: [
//                     {
//                         id: 30,
//                         label: 'menuitems.authentication.list.basic',
//                         link: '#',
//                         parentId: 29
//                     },
//                     {
//                         id: 31,
//                         label: 'menuitems.authentication.list.cover',
//                         link: '#',
//                         parentId: 29
//                     },
//                 ]
//             },
//             {
//                 id: 32,
//                 label: 'menuitems.authentication.list.lockscreen',
//                 subItems: [
//                     {
//                         id: 33,
//                         label: 'menuitems.authentication.list.basic',
//                         link: '#',
//                         parentId: 32
//                     },
//                     {
//                         id: 34,
//                         label: 'menuitems.authentication.list.cover',
//                         link: '#',
//                         parentId: 32
//                     },
//                 ]
//             },
//             {
//                 id: 35,
//                 label: 'menuitems.authentication.list.forgotpassword',
//                 subItems: [
//                     {
//                         id: 36,
//                         label: 'menuitems.authentication.list.basic',
//                         link: '#',
//                         parentId: 32
//                     },
//                     {
//                         id: 37,
//                         label: 'menuitems.authentication.list.cover',
//                         link: '#',
//                         parentId: 32
//                     },
//                 ]
//             },
//             {
//                 id: 38,
//                 label: 'menuitems.authentication.list.resetpwd',
//                 subItems: [
//                     {
//                         id: 39,
//                         label: 'menuitems.authentication.list.basic',
//                         link: '#',
//                         parentId: 38
//                     },
//                     {
//                         id: 40,
//                         label: 'menuitems.authentication.list.cover',
//                         link: '#',
//                         parentId: 38
//                     },
//                 ]
//             },
//             {
//                 id: 41,
//                 label: 'menuitems.authentication.list.emailverification',
//                 subItems: [
//                     {
//                         id: 42,
//                         label: 'menuitems.authentication.list.basic',
//                         link: '#',
//                         parentId: 41
//                     },
//                     {
//                         id: 43,
//                         label: 'menuitems.authentication.list.cover',
//                         link: '#',
//                         parentId: 41
//                     },
//                 ]
//             },
//             {
//                 id: 44,
//                 label: 'menuitems.authentication.list.twostepverification',
//                 subItems: [
//                     {
//                         id: 45,
//                         label: 'menuitems.authentication.list.basic',
//                         link: '#',
//                         parentId: 44
//                     },
//                     {
//                         id: 46,
//                         label: 'menuitems.authentication.list.cover',
//                         link: '#',
//                         parentId: 44
//                     },
//                 ]
//             },
//             {
//                 id: 47,
//                 label: 'menuitems.authentication.list.thankyou',
//                 subItems: [
//                     {
//                         id: 48,
//                         label: 'menuitems.authentication.list.basic',
//                         link: '#',
//                         parentId: 47
//                     },
//                     {
//                         id: 49,
//                         label: 'menuitems.authentication.list.cover',
//                         link: '#',
//                         parentId: 47
//                     },
//                 ]
//             }
//         ]
//     }
// ];

import { checkIfDisabled } from '@/helpers/helper.js';

export async function menuItems() {
    // return new Promise((resolve) => {
        
    //     resolve(items);
    // }) 
    let items = [
        // {
        //     label: 'Find Space',
        //     isTitle: true
        // },
        // {
        //     label: 'Browse Available Space',
        //     icon: 'search',
        //     link: { name: 'listings' },
        //     isDisabled: false,
        //     subItems: [
        //         {
        //             label: 'Browse Space Details',
        //             link: { name: 'browse-space-details' },
        //             isHidden: true,
        //             isDisabled: true
        //         }
        //     ]
        // },
        // {
        //     isSeparator: true
        // },
        // {
        //     label: 'My Checkout',
        //     icon: 'shopping-cart',
        //     link: { name: 'confirm-order' },
        //     // link: { name: 'my-checkout' },
        //     isDisabled: await checkIfDisabled('Find Space', 'My Checkout'),
        //     subItems: [
        //         {
        //             label: 'Confirm Orders',
        //             link: { name: 'confirm-order' },
        //             isHidden: true,
        //             isDisabled: true
        //         },
        //         {
        //             label: 'Collateral Setup',
        //             link: { name: 'collateral-setup' },
        //             isHidden: true,
        //             isDisabled: true
        //         }
        //     ]
        // },
        // {
        //     label: 'Favorites',
        //     icon: 'heart',
        //     link: { name: 'browse-space-favorites' },
        //     isDisabled: false,
        // },
        // {
        //     isSeparator: true
        // },
        {
            label: 'Manage Page',
            isTitle: true
        },
        {
            label: 'My Space',
            icon: 'material-symbols-outlined person_pin',
            link: { name: 'campaigns' },
            isDisabled: await checkIfDisabled('Manage Space', 'My Space'),
        },
        {
            label: 'Audit Space',
            icon: 'mdi mdi-ballot-outline',
            link: { name: 'audit-space' },
            isDisabled: false
            // badge: {
            //     variant: 'danger',
            //     text: '10',
            // }
        },
        {
            isSeparator: true
        },
        {
            label: 'User Management',
            icon: 'mdi mdi-account-group-outline',
            isDisabled: await checkIfDisabled('User Management'),
            subItems: [
                {
                    label: 'Users',
                    link: { name: 'users' },
                    isDisabled: await checkIfDisabled('User Management', 'Users'),
                },
                // {
                //     label: 'Roles',
                //     link: { name: 'roles' },
                //     isDisabled: await checkIfDisabled('User Management', 'Roles'),
                // },
            ]
        },
        {
            isSeparator: true
        },
    ];

    return items
}
